import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { ArgentinaMap } from '@/components/map/ArgentinaMap';
import { countByStatus, STATUS_LABELS } from '@/data/coverage';

export function Jurisdicciones() {
  const counts = countByStatus();
  const total = counts.covered + counts.progress + counts.pending;

  return (
    <>
      <Section className="pt-12 sm:pt-16">
        <Container width="editorial">
          <Eyebrow>Cobertura federal</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl font-normal tracking-tight sm:text-5xl">
            El sistema curricular argentino, jurisdicción por jurisdicción.
          </h1>
          <p className="mt-6 max-w-prose text-lg leading-relaxed text-ink-muted">
            24 diseños jurisdiccionales. Núcleos de Aprendizajes Prioritarios nacionales. Comparables
            y trazables.
          </p>
        </Container>
      </Section>

      <Section className="pt-0">
        <Container>
          <ArgentinaMap />
        </Container>
      </Section>

      <Section ariaLabelledby="cobertura-title" className="bg-paper-tinted/40">
        <Container width="editorial">
          <Eyebrow>Notas sobre cobertura</Eyebrow>
          <h2 id="cobertura-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Cómo entender el estado de cobertura.
          </h2>
          <dl className="mt-8 space-y-6">
            {(['covered', 'progress', 'pending'] as const).map((status) => (
              <div key={status} className="border-t border-line pt-4">
                <dt className="text-base font-semibold text-ink">
                  {STATUS_LABELS[status].label}
                  <span className="ml-3 text-sm font-normal text-ink-muted">
                    {counts[status]} de {total}
                  </span>
                </dt>
                <dd className="mt-2 text-base leading-relaxed text-ink-muted">
                  {STATUS_LABELS[status].description}
                </dd>
              </div>
            ))}
          </dl>
          <p className="prose-editorial mt-10 text-sm">
            Esta es la cobertura al lanzamiento. La actualizamos a medida que sumamos jurisdicciones
            al Inventario de Activos Curriculares. Si tu jurisdicción está pendiente y querés que la
            prioricemos, escribinos.
          </p>
        </Container>
      </Section>
    </>
  );
}
